module.exports = __webpack_public_path__ + "static/media/Mobile Crypto Wallet.be168a2a.png";